import React from 'react';
export function Clients() {
  return <section id="clients" className="py-32 bg-cream border-y border-[#D4AF37]/20 relative" data-id="element-89">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-90">
        <div className="flex items-center justify-center space-x-4 mb-16" data-id="element-91">
          <div className="h-px w-12 bg-gray-300" data-id="element-92"></div>
          <h2 className="text-xs font-cormorant font-bold tracking-[0.3em] text-gray-400 uppercase" data-id="element-93">
            Trusted by Esteemed Clients
          </h2>
          <div className="h-px w-12 bg-gray-300" data-id="element-94"></div>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-16 md:gap-32" data-id="element-95">
          <div className="group relative" data-id="element-96">
            <div className="absolute -inset-4 bg-gradient-to-r from-transparent via-[#D4AF37]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-97" />
            <h3 className="font-playfair text-3xl md:text-4xl font-bold text-gray-400 tracking-wider group-hover:text-navy transition-colors duration-500 relative z-10" data-id="element-98">
              INVESTCENT <br className="hidden md:block mt-2" data-id="element-99" />
              <span className="text-xl md:text-2xl font-light tracking-[0.2em] uppercase mt-2 block" data-id="element-100">
                Investment Bank Ltd
              </span>
            </h3>
          </div>

          <div className="hidden md:block w-px h-24 bg-gradient-to-b from-transparent via-[#D4AF37]/30 to-transparent" data-id="element-101"></div>

          <div className="group relative" data-id="element-102">
            <div className="absolute -inset-4 bg-gradient-to-r from-transparent via-[#D4AF37]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-xl" data-id="element-103" />
            <h3 className="font-playfair text-3xl md:text-4xl font-bold text-gray-400 tracking-wider group-hover:text-navy transition-colors duration-500 relative z-10" data-id="element-104">
              EQUITY BANK <br className="hidden md:block mt-2" data-id="element-105" />
              <span className="text-xl md:text-2xl font-light tracking-[0.2em] uppercase mt-2 block" data-id="element-106">
                (Kenya) Limited
              </span>
            </h3>
          </div>
        </div>
      </div>
    </section>;
}